import React from "react";
import "./Extraction.css";

const Extraction = () => {
  return (
    <div className="extraction">
      <div className="extraction__container">
      <div className="extraction__line" /> 
        <div className="extraction__left">
       
          <h1 className="extraction__title">Content Summarization</h1>
          <p className="extraction__text">
            Content Summarization is a great valuable tool for companies, which
            often have to deal with large amounts of unstructured text data.
            Using Google Gen AI, you have the possibility to process thousands
            of documents and get them classified and summarized giving you easy
            access to the information on your company.
          </p>
        </div>
        <div className="extraction__right">
          <img
            src="https://www.zazmic.com/wp-content/uploads/2023/10/clouds-ai.svg"
            alt="ai"
            className="extraction__img"
          />
        </div>
      </div>
    </div>
  );
};

export default Extraction;
